import { CircularProgress, Divider, Paper, Toolbar, Typography } from '@material-ui/core';
import React from 'react';
import DeleteButton from '../../../common/components/DeleteButton';
import Layout from '../../../common/components/Layout';
import ReturnButton from '../../../common/components/ReturnButton';
import { SimpleBreadcrumbs } from '../../../common/components/SimpleBreadcrumbs';
import { UserRestriction } from '../../../common/components/UserRestiction';
import { getProject } from '../../../common/services/project';
import { MatchVideoCard } from '../components/MatchVideoCard.component';
import { MatchVideoForm } from '../components/MatchVideoForm.component';
import { IMatchVideoPayload, MATCH_VIDEO_SOURCE_ADVERSPORT } from '../typings';
import { IComponentProps } from './MatchVideoDetail.connector';

interface IState {
  saving: boolean;
}

export class MatchVideoDetail extends React.Component<IComponentProps, IState> {
  public state: IState = { saving: false };

  public componentDidMount() {
    this.props.fetchMatchVideo(this.props.id);
  }

  public componentDidUpdate(prevProps: IComponentProps) {
    if (prevProps.id !== this.props.id) {
      this.props.fetchMatchVideo(this.props.id);
    }
  }

  public render() {
    const {
      video,
      fetching,
      intl: { messages: m },
    } = this.props;

    const match = video && (video.match as any);
    const matchLabel = match
      ? match.description || `${match.homeTeam ? match.homeTeam.name : '?'} vs ${match.awayTeam ? match.awayTeam.name : '?'}`
      : null;

    return (
      <Layout
        id="match-video-detail-layout"
        top={
          <SimpleBreadcrumbs
            crumbStack={[
              { labelKey: 'app_matchVideos', href: `#${getProject().url}/match-videos` },
              ...(matchLabel ? [{ label: matchLabel, href: `#${getProject().url}/matches/${match.id}/match-videos` }] : []),
            ]}
          />
        }
        main={
          !video && fetching ? (
            <CircularProgress size={80} style={{ margin: 'auto' }} />
          ) : !video ? null : (
            <Paper elevation={2}>
              <Toolbar>
                <Typography variant="h6">{m.app_matchVideoEdit}</Typography>
                <div style={{ flex: 1 }} />
                <ReturnButton entity="match-videos" />
              </Toolbar>
              <MatchVideoCard video={video} />
              <Divider />
              <UserRestriction>
                {video.metaImportSource !== MATCH_VIDEO_SOURCE_ADVERSPORT && (
                  <Typography variant="body2" color="textSecondary" style={{ padding: '16px 16px 0' }}>
                    {m.help_matchVideoClaim}
                  </Typography>
                )}
                <MatchVideoForm
                  key={video.updatedAt || video.id}
                  initial={video}
                  saving={this.state.saving}
                  onSubmit={this.handleSubmit}
                  extraActions={<DeleteButton onRemove={this.handleDelete} disabled={this.state.saving} />}
                />
              </UserRestriction>
            </Paper>
          )
        }
      />
    );
  }

  private handleSubmit = (payload: IMatchVideoPayload) => {
    const { updateMatchVideo, id } = this.props;

    this.setState({ saving: true });
    // @ts-ignore - thunk returns a promise
    updateMatchVideo(id, payload).then(() => this.setState({ saving: false }));
  };

  private handleDelete = () => {
    const { deleteMatchVideo, id, history } = this.props;

    // @ts-ignore - thunk returns a promise
    deleteMatchVideo(id).then(({ type }) => {
      if (type === 'DELETE_MATCH_VIDEO_FULFILLED') {
        history.push(`${getProject().url}/match-videos`);
      }
    });
  };
}
